module.exports = __webpack_public_path__ + "img/destination_selous_ln.6d7dcc50.jpg";